

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const ASIGNAR_CAMPOS_MUNI = "asignarCamposMuni";
export const OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO = "obtenerCamposPorDepto";
export const OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO_MUNI = "obtenerCamposPorMuni";


// mutation types
export const SET_CAMPOS_RESULTADOS = "setCamposResultados";
export const SET_CAMPO_RESULTADOS = "setCampoResultados";

const state = {
    camposResultados: [],
    campoResultados:[],
}

const getters = {
    obtenerCamposMuniPeriodo(state) {
      return state.camposResultados;
    },
}

const actions = {

    /**
     * Asignar campos de resultados a municipalidades de forma parcial o para todas las munis
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [ASIGNAR_CAMPOS_MUNI](context, datos){

        let endpoint=`/api/CamposMuniPeriodo/all/asignar`;
        
        //?Si el tipo es 2, es de forma parcial
        if(datos.tipo===2){
            endpoint=`api/CamposMuniPeriodo/partial/asignar`;
        }


        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_CAMPOS_RESULTADOS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
         
    },


    /**
     * Obtener las campos asignados a cada municipio por departamento indice y periodo
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO](context, datos){

        let endpoint = `api/CamposMuniPeriodo/${Number(datos.deptoId)}/${Number(datos.indiceId)}/${Number(datos.periodoId)}`;

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_CAMPOS_RESULTADOS,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    /**
     * Obtener las campos asignados de cada municipio por departamento indice, periodo y municipio
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO_MUNI](context, datos){

        let endpoint = `api/CamposMuniPeriodo/importar/${Number(datos.municipioId)}/${Number(datos.indiceId)}/${Number(datos.periodoId)}`;

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_CAMPOS_RESULTADOS,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },




    
  }

const mutations = {
    [SET_CAMPOS_RESULTADOS](state, data) {
        state.camposResultados = data;
    },

    [SET_CAMPO_RESULTADOS](state, data) {
        state.campoResultados = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}